import { ScreenWidthMaxMedium, ScreenWidthMaxSmall, ScreenWidthMinMedium, getScreenSelector, } from 'office-ui-fabric-react/lib/Styling';
export var borderWidth = '1px';
export var borderWidthError = '2px';
export var borderSolid = 'solid';
export var borderNone = 'none';
export var fontFamily = 
// eslint-disable-next-line @fluentui/max-len
'Segoe UI, "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue",sans-serif';
export var fontWeightBold = '700';
export var inputControlHeight = '24px';
export var inputControlHeightInner = '20px';
export var textAlignCenter = 'center';
export var transparent = 'transparent';
export var MinimumScreenSelector = getScreenSelector(0, ScreenWidthMaxSmall);
export var MediumScreenSelector = getScreenSelector(ScreenWidthMinMedium, ScreenWidthMaxMedium);
